import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";

export function LLMAdminOnlyBadge() {
  const { t } = useTranslation();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="warning">
            {t("team.components.llmPermissions.badges.adminOnly")}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-sm">
            {t("team.components.llmPermissions.tooltip.adminOnly")}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
